// Categories and Sub-categories data structure
export const categories = [
  {
    categoryId: "ready-to-eat",
    categoryName: "Ready-to-Eat",
    description: "Prepared food items ready for immediate consumption",
    subCategories: [
      { subCategoryId: "sandwiches", subCategoryName: "Sandwiches" },
      { subCategoryId: "wraps", subCategoryName: "Wraps" },
      { subCategoryId: "salads", subCategoryName: "Salads" },
      { subCategoryId: "soups", subCategoryName: "Soups" },
      { subCategoryId: "snacks", subCategoryName: "Snacks" },
      { subCategoryId: "dips", subCategoryName: "Dips & Spreads" }
    ]
  },
  {
    categoryId: "heat-and-eat",
    categoryName: "Heat & Eat",
    description: "Food items that require heating before consumption",
    subCategories: [
      { subCategoryId: "entrees", subCategoryName: "Entrees" },
      { subCategoryId: "sides", subCategoryName: "Side Dishes" },
      { subCategoryId: "pasta", subCategoryName: "Pasta Dishes" },
      { subCategoryId: "casseroles", subCategoryName: "Casseroles" },
      { subCategoryId: "sauces", subCategoryName: "Sauces & Gravies" }
    ]
  },
  {
    categoryId: "baked-goods",
    categoryName: "Baked Goods",
    description: "Items from the bakery, both sweet and savory",
    subCategories: [
      { subCategoryId: "breads", subCategoryName: "Breads" },
      { subCategoryId: "sweet-pastries", subCategoryName: "Sweet Pastries" },
      { subCategoryId: "savory-pastries", subCategoryName: "Savory Pastries" },
      { subCategoryId: "cookies", subCategoryName: "Cookies" },
      { subCategoryId: "cakes", subCategoryName: "Cakes" },
      { subCategoryId: "muffins", subCategoryName: "Muffins" }
    ]
  },
  {
    categoryId: "beverages",
    categoryName: "Beverages",
    description: "Drinks and liquid refreshments",
    subCategories: [
      { subCategoryId: "hot-drinks", subCategoryName: "Hot Drinks" },
      { subCategoryId: "cold-drinks", subCategoryName: "Cold Drinks" },
      { subCategoryId: "smoothies", subCategoryName: "Smoothies" },
      { subCategoryId: "juices", subCategoryName: "Juices" },
      { subCategoryId: "milkshakes", subCategoryName: "Milkshakes" }
    ]
  },
  {
    categoryId: "desserts",
    categoryName: "Desserts",
    description: "Sweet treats and dessert items",
    subCategories: [
      { subCategoryId: "ice-cream", subCategoryName: "Ice Cream" },
      { subCategoryId: "puddings", subCategoryName: "Puddings" },
      { subCategoryId: "pies", subCategoryName: "Pies" },
      { subCategoryId: "candies", subCategoryName: "Candies" },
      { subCategoryId: "chocolates", subCategoryName: "Chocolates" }
    ]
  },
  {
    categoryId: "condiments",
    categoryName: "Condiments",
    description: "Sauces, seasonings, and flavor enhancers",
    subCategories: [
      { subCategoryId: "hot-sauces", subCategoryName: "Hot Sauces" },
      { subCategoryId: "dressings", subCategoryName: "Dressings" },
      { subCategoryId: "spices", subCategoryName: "Spices & Seasonings" },
      { subCategoryId: "jams", subCategoryName: "Jams & Jellies" },
      { subCategoryId: "oils", subCategoryName: "Oils & Vinegars" }
    ]
  }
];

// Helper functions for category management
export const getCategoryById = (categoryId) => {
  return categories.find(category => category.categoryId === categoryId);
};

export const getSubCategoryById = (categoryId, subCategoryId) => {
  const category = getCategoryById(categoryId);
  if (!category) return null;
  return category.subCategories.find(sub => sub.subCategoryId === subCategoryId);
};

export const getSubCategoriesByCategoryId = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category ? category.subCategories : [];
};

export const getAllCategories = () => {
  return categories;
};

export const getCategoryNameById = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category ? category.categoryName : '';
};

export const getSubCategoryNameById = (categoryId, subCategoryId) => {
  const subCategory = getSubCategoryById(categoryId, subCategoryId);
  return subCategory ? subCategory.subCategoryName : '';
}; 